export enum ColorModesEnum {
  LIGHT_MODE = 'light-mode',
  DARK_MODE = 'dark-mode',
}
